<template>
  <div class="customer-create main-content">
    <div class="page-header">
      <h3 class="page-title">
        {{ $t('islamic_finance.title') }}
      </h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link
            slot="item-title"
            to="dashboard">
            {{ $t('general.home') }}
          </router-link>
        </li>
        <li v-if="userType==='supplier'" class="breadcrumb-item">
          <router-link
            slot="item-title"
            to="/supplier/funders">
            {{ $tc('funders.finance',2) }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            v-if="userType==='supplier'"
            slot="item-title"
            :to="{ name: 'FunderFinance', params: { id: this.$route.params.funder_id }}">
            {{ $t('islamic_finance.title') }}
          </router-link>
          <router-link
            v-else-if="userType=='funder'"
            slot="item-title" to="/funder/islamic-finances">
            {{ $t('islamic_finance.title') }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#">
            {{ $tc('invoices.attachments', 2) }}
          </router-link>
        </li>
      </ol>
      <div class="page-actions row">
        <div class="col-xs-2 mr-4">
          <base-button
            size="large"
            icon="plus"
            color="theme"
            @click="addAttachment()"
          >
            {{ $t('invoices.newAttachment') }}
          </base-button>
        </div>
        <div v-if="userType==='funder' && currentStatusHash" class="col-xs-2 mr-4">
          <a :href="`/islamic_finance/Attachment/${currentStatusHash}`" target="_blank" class="btn btn-outline-primary" outline color="theme">
            Download Current Attachments
          </a>
        </div>
      </div>
    </div>
    <single-funder-row v-if="userType==='supplier'" :fetch-data="fetchDataFunder"/>
    <single-finance-row :fetch-data="fetchFinanceData"/>

    <div v-show="!showEmptyScreen" class="table-container">
      <div class="table-actions mt-5">
        <p class="table-stats">{{ $t('general.showing') }}: <b>{{ attachments.length }}</b></p>

        <transition name="fade">
          <v-dropdown v-if="selectedAttachments.length" :show-arrow="false">
            <span slot="activator" href="#" class="table-actions-button dropdown-toggle">
              {{ $t('general.actions') }}
            </span>
            <!-- <v-dropdown-item v-if="advanceOption && invoiceStatus=='DRAFT'">
              <div class="dropdown-item" @click="removeMultipleAttachments"  >
                <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
                {{ $t('general.delete') }}
              </div>
            </v-dropdown-item> -->
          </v-dropdown>
        </transition>
      </div>

      <div class="custom-control custom-checkbox">
        <input
          id="select-all"
          v-model="selectAllFieldStatus"
          type="checkbox"
          class="custom-control-input"
          @change="selectAllAttachments"
        >
        <label for="select-all" class="custom-control-label selectall">
          <span class="select-all-label">{{ $t('general.select_all') }} </span>
        </label>
      </div>

      <table-component
        ref="table"
        :show-filter="false"
        :data="attachments"
        table-class="table"
      >
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="no-click"
        >
          <template slot-scope="row">
            <div class="custom-control custom-checkbox">
              <input
                :id="row.id"
                v-model="selectField"
                :value="row.id"
                type="checkbox"
                class="custom-control-input"
              >
              <label :for="row.id" class="custom-control-label"/>
            </div>
          </template>
        </table-column>
        <table-column
          :label="$tc('documents.documentType', 1)"
          show="documentType.name"
        />
        <table-column
          :label="$t('documents.document')"
          show="name"
        />
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <span> {{ $t('customers.action') }} </span>
            <v-dropdown>
              <a slot="activator" href="#"><dot-icon /></a>
              <v-dropdown-item>
                <div class="dropdown-item">
                  <a v-if="row.path" :href="row.path" target="_blank" >
                    <font-awesome-icon icon="eye" class="dropdown-item-icon" />
                    {{ $t('general.view') }}
                  </a>
                </div>
              </v-dropdown-item>
              <!-- <v-dropdown-item v-if="advanceOption && invoiceStatus=='DRAFT'">
                <div class="dropdown-item" @click="deleteDocument(row)">
                  <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
                  {{ $t('general.delete') }}
                </div>
              </v-dropdown-item> -->
            </v-dropdown>
          </template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import DotIcon from '../../components/icon/DotIcon'
import AstronautIcon from '../../components/icon/AstronautIcon'
import BaseButton from '../../../js/components/base/BaseButton'
import SingleFunderRow from '../funders/SingleFunderRow.vue'
import SingleFinanceRow from './SingleIslamicFinanceRow.vue'
export default {
  components: {
    DotIcon,
    AstronautIcon,
    SweetModal,
    SweetModalTab,
    BaseButton,
    SingleFunderRow,
    SingleFinanceRow

  },
  data () {
    return {
      filtersApplied: false,
      isRequestOngoing: true,
      fetchDataFunder: [],
      fetchFinanceData: [],
      userType: null,
      draftTermCondition: null,
      currentStatusHash: null
    }
  },
  computed: {
    ...mapGetters('OfferToSell', [
      'offerToSells',
      'selectedOfferToSells',
      'totalOfferToSells',
      'selectAllFieldAttachment',
      'attachments',
      'totalAttachments',
      'selectedAttachments'
    ]),
    ...mapGetters('islamicFinanceForm', [
      'islamicFinanceForm'
    ]),
    showEmptyScreen () {
      return !this.totalAttachments && !this.isRequestOngoing
    },
    offerAcceptForm () {
      return this.islamicFinanceForm.find(x => x.name === 'Offer Accepted')
    },
    selectField: {
      get: function () {
        return this.selectedAttachments
      },
      set: function (val) {
        this.selectAttachment(val)
      }
    },
    selectAllFieldStatus: {
      get: function () {
        return this.selectAllFieldAttachment
      },
      set: function (val) {
        this.setSelectAllState(val)
      }
    }
  },
  watch: {
    filters: {
      handler: 'setFilters',
      deep: true
    }
  },
  created () {
    console.log('ooo')
    if (localStorage.getItem('role') === 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') === 'anchor') {
      this.userType = 'anchor'
    } else if (localStorage.getItem('account_type') === 'funder') {
      this.userType = 'funder'
    } else if (localStorage.getItem('account_type') === 'supplier') {
      this.userType = 'supplier'
      this.loadFunder()
    }
    this.loadFinance()
    this.Attachments()
  },

  destroyed () {
    if (this.selectAllFieldAttachment) {
      // this.selectAllOfferToSells()
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('OfferToSell', [
      'fetchOfferToSells',
      'SingleIslamicFinanceArray',

      'deleteAttachment',
      'fetchAttachments',
      'selectAllAttachments',
      'setSelectAllState',
      'selectAttachment',
      'deleteMultipleAttachments'
    ]),
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('funder', [
      'singleFunderArray'
    ]),
    refreshTable () {
      this.$refs.table.refresh()
    },
    async loadFunder () {
      let response = await this.singleFunderArray(this.$route.params.funder_id)
      this.fetchDataFunder = response.data.account
    },
    async loadFinance () {
      let response = await this.SingleIslamicFinanceArray(this.$route.params.id)
      if (response.data) {
        this.fetchFinanceData = response.data.islamicFinance
      }
    },
    async Attachments () {
      const data = {islamic_finance_id: this.$route.params.id}
      let response = await this.fetchAttachments(data)
      if (response && response.data && response.data.islamicFinance && response.data.islamicFinance.unique_hash) {
        this.currentStatusHash = response.data.islamicFinance.unique_hash
      }
      this.isRequestOngoing = false
      return response.data
    },
    async addAttachment () {
      this.openModal({
        'title': 'Add Attachment',
        'componentName': 'IslamicFinanceAttachmentModal'
      })
    }
  }
}
</script>
